module.exports = __webpack_public_path__ + "static/Group 7205-865125d43cb7412b480ce75dbcbc891c.png";